import angular from "angular";
import panel from "../services";

function userNotifications (panel) {
  return {
    restrict: 'E',

    link: (scope, element) => {
      scope.matches = [];
      scope.views = [];
      scope.favourites = [];
      scope.likes = [];

      panel.get('/v1/activity/feed', (response) => {
        if (panel.okay(response)) {
          scope.matches = response.feed.matches;
          scope.views = response.feed.views;
          scope.favourites = response.feed.favourites;
          scope.likes = response.feed.likes;
        }
      });

      let elem = new Foundation.Tabs($("#activity-tabs"), {});

      scope.size = (activity_id, them) => {

        let activity_source = !them ? 'activity' : 'activity_news';
        if (typeof scope.dashboard !== 'undefined') {
          for (let i in scope.dashboard[activity_source]) {
            if (scope.dashboard[activity_source][i].activity_id === activity_id) {
              return scope.dashboard[activity_source][i].size;
            }
          }
        }
        return 0;
      }

      scope.loader = (activity_id, them, icon) => {

        let pb = $('.popup-activity-items');

        if (!pb.hasClass('popup-loader')) {

          scope.activity.ilog_size = scope.ilog.length;

          pb.addClass('popup-loader');

          let page = 0;

          scope.activity.is_loading_activity = false;

          pb.scroll(function () {

            if (!scope.activity.is_loading_activity) {
              scope.activity.is_loading_activity = true;
              scope.activity.popup(activity_id, them, icon, ++page);
            }
          });
        }
      }

      scope.update = (page) => {

        if (!scope.activities_size) {
          scope.activities_size = scope.activities.size;
        }

        let url = '/v1/activity/user?activity_id=' + scope.selected;

        if (page) {
          url += '&page=' + page;
        } else {
          scope.page = 0;
        }

        const self = this;

        scope.panel.get(url, function (response) {

          if (scope.panel.okay(response)) {

            if (page) {
              if (response.log.size >= scope.activities_size) {
                scope.fetching = false;
              }
              scope.activities = scope.activities.concat(response.log);
            } else {
              scope.fetching = false;
              scope.activities = response.log;
            }
          }
        });
      }
    },

    template: require('./templates/user-notifications.html')
  }
}

export default angular.module('directives.userNotifications', [panel]).directive('userNotifications', userNotifications).name;



// WEBPACK FOOTER //
// ./src/app/directives/userNotifications.js